import { ReactComponent as GoldClass } from "../assets/card-icons/gold_class.svg";
import { ReactComponent as SilverClass } from "../assets/card-icons/silver_class.svg";
import { ReactComponent as BronzeClass } from "../assets/card-icons/bronze_class.svg";
import { ReactComponent as Sets } from "../assets/card-icons/sets.svg";
import { ReactComponent as GreenSets } from "../assets/card-icons/greenSet.svg";
import { ReactComponent as Tag } from "../assets/child-header-icons/tag.svg";
import { ReactComponent as Score } from "../assets/child-header-icons/score.svg";
import { ReactComponent as Category } from "../assets/icons/category.svg";
import { ReactComponent as Category_B } from "../assets/child-header-icons/cat.svg";
import { ReactComponent as Scale } from "../assets/card-icons/card_scale.svg";
import { ReactComponent as GreyScale } from "../assets/card-icons/long_card_scale.svg";
import { ReactComponent as Ring } from "../assets/icons/ring.svg";
import { ReactComponent as Ring_B } from "../assets/child-header-icons/ring.svg";
import { ReactComponent as Gold } from "../assets/card-icons/card_gold.svg";
import { ReactComponent as Coloured_Gold } from "../assets/icons/gold.svg";
import { ReactComponent as GreyGold } from "../assets/card-icons/long_card_gold.svg";
import { ReactComponent as GoldBar } from "../assets/child-header-icons/gold_bar.svg";
import { ReactComponent as Coloured_Back_Gold } from "../assets/child-header-icons/coloured_gold.svg";
import { ReactComponent as Diamond } from "../assets/card-icons/card_diamond.svg";
import { ReactComponent as Coloured_Diamond } from "../assets/icons/diamond.svg";
import { ReactComponent as GreyDiamond } from "../assets/card-icons/long_card_diamond.svg";
import { ReactComponent as Diamond_B } from "../assets/child-header-icons/diamond_bnw.svg";
import { ReactComponent as Coloured_Back_Diamond } from "../assets/child-header-icons/coloured_diamond.svg";
import { ReactComponent as EyeIcon } from "../assets/icons/order_icon/eye_icon.svg";
import { ReactComponent as EditIcon } from "../assets/icons/order_icon/edit_icon.svg";
import { ReactComponent as EmailIcon } from "../assets/icons/order_icon/email_icon.svg";
import { ReactComponent as PdfIcon } from "../assets/icons/order_icon/pdf_icon.svg";
import { ReactComponent as WhatsappIcon } from "../assets/icons/order_icon/whatsapp_icon.svg";
import { ReactComponent as DarkIconSearch } from "../assets/icons/client_icon/dark_search_icon.svg";
import { ReactComponent as SearchGreyIcon } from "../assets/icons/search_grey.svg";
import { ReactComponent as WhiteSearchIcon } from "../assets/icons/search.svg";
import { ReactComponent as Remove } from "../assets/card-icons/dustbin.svg";
import { ReactComponent as Cross } from "../assets/icons/order_icon/cross.svg";
import { ReactComponent as BigCross } from "../assets/icons/big_cross.svg";
import { ReactComponent as CheckCircleIcon } from "../assets/icons/client_icon/Green_Circle_Tick.svg";
import { ReactComponent as Play } from "../assets/icons/newplay.svg";
import { ReactComponent as LeftArrow } from "../assets/icons/client_icon/leftArrow_5.svg";
import { ReactComponent as DownArrow } from "../assets/icons/order_icon/date_picker/white_down_arrow.svg";
import { ReactComponent as DarkDownArrow } from "../assets/icons/order_icon/date_picker/down_arrow.svg";
import { ReactComponent as RightArrow } from "../assets/icons/Arrow.svg";
import { ReactComponent as PrevIcon } from "../assets/icons/PrevImageBox.svg";
import { ReactComponent as NextIcon } from "../assets/icons/NextImageBox.svg";
import { ReactComponent as AddIcon } from "../assets/icons/AddIcon.svg";
import { ReactComponent as RemoveIcon } from "../assets/icons/AddedIcon.svg";
import { ReactComponent as SalesPersonCancel } from "../assets/icons/SalesPersonCancel.svg";
import { ReactComponent as SalesPersonDropBox } from "../assets/icons/salesPersonDropBox.svg";
import { ReactComponent as CircleTick} from "../assets/icons/CircleTickMark.svg";
import { ReactComponent as CircleCross} from "../assets/icons/CircleCrossMark.svg";
import { ReactComponent as ArrowCircleLeft} from "../assets/icons/arrowCircleLeft.svg";
import { ReactComponent as RestrictIcon} from "../assets/icons/order_icon/restrictIcon.svg";
import { ReactComponent as SyncIcon} from "../assets/icons/order_icon/sync.svg";
import { ReactComponent as PinkGoldbar } from "../assets/icons/cart_icons/pink_gold.svg";
import { ReactComponent as YellowGoldbar } from "../assets/icons/cart_icons/yellow_gold.svg";
import { ReactComponent as WhiteGoldbar } from "../assets/icons/cart_icons/white_gold.svg";
import { ReactComponent as InfoIcon } from "../assets/icons/Info_black.svg";
import {ReactComponent as StyleIcon} from "../assets/icons/stock_icons/Style_Icon.svg";
import {ReactComponent as GemStoneIcon} from "../assets/icons/stock_icons/Gem_Stone_Icon.svg";
import {ReactComponent as OtherMaterialIcon} from "../assets/icons/stock_icons/Other_Material_Icon.svg";
import {ReactComponent as WhiteRing} from "../assets/icons/stock_icons/White_ring.svg";
import {ReactComponent as BBM} from "../assets/icons/stock_icons/BBM.svg";
import {ReactComponent as BBS} from "../assets/icons/stock_icons/BBS.svg";
import {ReactComponent as HQ} from "../assets/icons/stock_icons/HQ.svg";
import {ReactComponent as BBMCustomer} from "../assets/icons/stock_icons/bbm_cust.svg";
import {ReactComponent as BBSCustomer} from "../assets/icons/stock_icons/bbs_cust.svg";
import {ReactComponent as Bronze} from "../assets/icons/stock_icons/bronze.svg";
import {ReactComponent as Silver} from "../assets/icons/stock_icons/sliver.svg";
import {ReactComponent as Sync} from "../assets/icons/order_icon/sync.svg";
import {ReactComponent as Memo} from "../assets/icons/stock_icons/MoIcon.svg";
import {ReactComponent as IDL} from "../assets/icons/stock_icons/IdlIcon.svg";
import {ReactComponent as Rhodium} from "../assets/card-icons/Rhodium.svg";
import {ReactComponent as PoNo} from "../assets/card-icons/PoNo icon.svg";
import {ReactComponent as Calender} from "../assets/card-icons/Calender.svg";
import {ReactComponent as GemStone} from "../assets/card-icons/GemStone.svg";
import {ReactComponent as OtherMaterial} from "../assets/card-icons/OtherMaterial.svg";
import {ReactComponent as Sale} from "../assets/card-icons/sale.svg";
import {ReactComponent as CatalogIcon} from "../assets/icons/catalogIcon.svg";


export const getIcon = (type, variant) => {
  const icons = {
    Gold: <GoldClass />,
    Silver: <SilverClass />,
    Bronze: <BronzeClass />,
    Diamond:
      variant === "back" ? (
        <Diamond_B />
      ) : variant === "dark" ? (
        <GreyDiamond />
      ) : variant === "coloured" ? (
        <Coloured_Diamond />
      ) : variant === "coloured_back" ? (
        <Coloured_Back_Diamond />
      ) : variant === "stock_diamond" ? (
        <Diamond width={".75vw"} height={".75vw"} />
      ) : (
        <Diamond />
      ),
    GoldBar:
      variant === "back" ? (
        <GoldBar />
      ) : variant === "dark" ? (
        <GreyGold />
      ) : variant === "coloured" ? (
        <Coloured_Gold />
      ) : variant === "coloured_back" ? (
        <Coloured_Back_Gold />
      ) : variant === "gold_stock" ? (
        <Gold width={".75vw"} height={".6vw"} />
      ) : (
        <Gold />
      ),
    Ring: variant === "back" ? <Ring_B /> : variant === "white" ? <WhiteRing width={"0.9vw"} height={"0.9vw"} /> : <Ring />,
    Category: variant === "back" ? <Category_B /> : <Category />,
    Scale: 
      variant === "dark" ? (
        <GreyScale /> 
      ) : variant === "scale_stock" ? (
        <Scale  />
      ) : (
        <Scale width={".75vw"} height={".75vw"} />
      ),
    Search:
      variant === "dark" ? (
        <DarkIconSearch />
      ) : variant === "grey" ? (
        <SearchGreyIcon />
      ) : (
        <WhiteSearchIcon />
      ),
    RightArrow: <RightArrow />,
    LeftArrow: <LeftArrow />,
    DownArrow: variant === "dark" ? <DarkDownArrow /> : <DownArrow />,
    CheckCircleIcon: <CheckCircleIcon />,
    Play: <Play />,
    Cross: variant === "big" ? <BigCross /> : <Cross />,
    dustbin: <Remove />,
    Sets: variant === "green" ? <GreenSets /> : <Sets />,
    Tag: <Tag />,
    Score: <Score />,
    email: <EmailIcon />,
    pdf: <PdfIcon />,
    edit: <EditIcon />,
    WhatsApp: <WhatsappIcon />,
    eye: <EyeIcon />,
    PrevIcon: <PrevIcon />,
    NextIcon: <NextIcon />,
    AddIcon: <AddIcon/>,
    RemoveIcon: <RemoveIcon/>,
    circleTick:<CircleTick />,
    circleCross:<CircleCross />,
    ArrowCircleLeft:<ArrowCircleLeft />,
    RestrictIcon:<RestrictIcon />,
    SyncIcon : < SyncIcon />,
    SalesPerson: variant === "cancel" ?  <SalesPersonCancel/> : <SalesPersonDropBox/>,
    GoldBarIconInfo: variant === "Y" ? <YellowGoldbar /> : variant === "P" ? <PinkGoldbar /> : <WhiteGoldbar />,
    info: <InfoIcon />,
    StyleIcon: variant === "bronze" ? (
      <Bronze width={"0.75vw"} height={".75vw"} />
    ) : variant === "silver" ? (
      <Silver width={"0.75vw"} height={".75vw"} />
    ) : variant === "gold" ? (
      <StyleIcon width={"0.75vw"} height={".75vw"} />
    ) : "",
    GemStoneIcon: <GemStoneIcon  width={".8vw"} height={".8vw"} />,
    OtherMaterialIcon: <OtherMaterialIcon />,
    hq: <HQ />,
    bbm: <BBM />,
    bbs: <BBS />,
    bbmC: <BBMCustomer />,
    bbsC: <BBSCustomer />,
    Sync: <Sync />,
    Memo: <Memo />,
    IDL: <IDL />,
    Rhodium: <Rhodium width={"0.75vw"} height={"0.75vw"} />,
    PoNo: <PoNo />,
    Calender: <Calender width={"0.7vw"} height={"0.7vw"}  />,
    GemStone: <GemStone width={"0.7vw"} height={"0.7vw"}  />,
    OtherMaterial: <OtherMaterial width={"0.7vw"} height={"0.7vw"}  />,
    Sale: <Sale width={"0.7vw"} height={"0.7vw"}  />,
    Catalog: <CatalogIcon />,
  };

  return icons[type] || null;
};
